import './DialogVisualiserDocument.scss';

import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, IconButton, Toolbar } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { API_SERVER_FILES } from '../../config';
import { typeDocument } from '../../data/Interfaces';
import { CalendarIcons } from '../../data/SVGs';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { getExtensionUrl, searchLabelInEnumByValue } from '../../Utils/utils';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { IconTextField, TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
import DialogRejet from './DialogRejet';

const DialogVisualiserDocument = ({ handleClose, open, document, getDocumentAdministratifs }) => {

    DialogVisualiserDocument.propTypes = {
        children: PropTypes.any,
        getDocumentAdministratifs: PropTypes.func,
        document: PropTypes.any,
        open: PropTypes.any,
        handleClose: PropTypes.func,
    };

    const [openDialogRejet, setOpenDialogRejet] = useState(false);
    const {device}=useWindowSize();
    const descriptionElementRef = React.useRef(null);
    const { i18n } = useTranslation();
    // ? we focus on what here
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const { setBackdropOpen } = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const validerDocument = async (docid, statut) => {
        setBackdropOpen(true);
        axiosPrivate.post('docAdministratif/changeDocStatus', { docId: docid, statut: statut })
            .then(() => { getDocumentAdministratifs(); })
            .catch(error => console.log(error));
        setBackdropOpen(false);
        handleClose();
    };
    const scroll = 'paper';

    console.log('document?.noDoc ',document?.noDoc );
    return (
        <>
            <Dialog
                fullScreen
                open={open}
                TransitionComponent={Transition}
                onClose={handleClose}
                scroll={scroll}
                PaperProps={{
                    style: {
                        background: '#F5F6FA',
                    },
                }}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <AppBar>
                    {/*sx={{ position: 'relative', bgcolor: '#FFFFFF', color: '#000000' }}*/}

                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'20px':'0px',minHeight:'1100px',paddingTop:'54px'}}>

                    {/*
                    // * SOL 1
                <iframe
        src="https://docs.google.com/gview?url=https://www.cdc.gov/polio/stop/doc/stop-cv-format.doc&embedded=true"
        ></iframe>
        // * SOL 2
        <iframe
        src="https://docs.google.com/viewerng/viewer?url=https://www.cdc.gov/polio/stop/doc/stop-cv-format.doc"
        ></iframe>
        // * SOL 3
        <iframe
        src="https://view.officeapps.live.com/op/embed.aspx?src=https://www.cdc.gov/polio/stop/doc/stop-cv-format.doc" // see also: https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fpublichthimages.s3.eu-west-3.amazonaws.com%2Fuploads%2Fdocuments%2Fcv%2F1709818421713-1705071602159-cv-abdeladim.docx&wdOrigin=BROWSELINK
        width="1366px"
        height="623px"
        frameborder="0"
        >This is an embedded
        <a target="_blank" href="http://office.com">Microsoft Office</a> document,
        powered by
        <a target="_blank" href="http://office.com/webapps">Office Online</a>.
        </iframe> */}

                    {/*faut travailler avec les extensions au lieu du (titre) pas oublier word .docx*/}
                    {/*{document?.titre!='cinRecto'?*/}
                    {/*<>
                                <img
                                    src={API_SERVER_FILES + document?.url}
                                    height='50%'
                                    width='100%'
                                />
                                <img
                                    src={API_SERVER_FILES + document?.verso}
                                    height='50%'
                                    width='100%'
                                />
                            </>*/}
                    {document?.url &&
                        <div className='frame0DialogVisualiserDocument'>
                            {getExtensionUrl(document?.url)=='pdf' &&
                                <iframe
                                    src={API_SERVER_FILES + encodeURIComponent(document?.url)}
                                    height={document?.titre=='cinRecto'? '50%' : '100%'}
                                    width='100%'
                                />
                            }
                            {(getExtensionUrl(document?.url)=='docx' ||getExtensionUrl(document?.url)=='doc') &&
                                <iframe
                                    src={'https://docs.google.com/gview?url='+API_SERVER_FILES +document?.url+'&embedded=true'}
                                    height={'100%'}
                                    width='100%'
                                ></iframe>
                                //<iframe
                                //    src={'https://docs.google.com/viewerng/viewer?url='+ API_SERVER_FILES +document?.url}
                                //    height={document?.titre=='cinRecto'? '50%' : '100%'}
                                //    width='100%'
                                ///>
                            }
                            {((getExtensionUrl(document?.url)=='jpeg' ||getExtensionUrl(document?.url)=='jpg'||getExtensionUrl(document?.url)=='png') && document?.titre=='cinRecto' ) &&
                                <>
                                    <img
                                        src={API_SERVER_FILES + encodeURIComponent(document?.url)}
                                        height='50%'
                                        width='100%'
                                    />
                                    <img
                                        src={API_SERVER_FILES + encodeURIComponent(document?.verso)}
                                        height='50%'
                                        width='100%'
                                    />
                                </>
                            }
                            {((getExtensionUrl(document?.url)=='jpeg' ||getExtensionUrl(document?.url)=='jpg'||getExtensionUrl(document?.url)=='png') && document?.titre!='cinRecto' ) &&
                                <img
                                    src={API_SERVER_FILES + encodeURIComponent(document?.url)}
                                    height='100%'
                                    width='100%'
                                />
                            }
                        </div>
                    }
                    {device!='desktop' &&
                        <div className='frame8DialogVisualiserDocument'>

                            <Button
                                variant='text'
                                style={{...buttonStyles(),
                                    ...{
                                        borderColor:'#EC5B56',color:'#EC5B56',order:device=='desktop'?'0':'1',width: device=='desktop'?'91px':'100%',}
                                }}
                                onClick={() => {
                                    setOpenDialogRejet(true);

                                }}
                            >
                                {i18n.t('Rejeter')}
                            </Button>

                            <Button
                                variant='contained'
                                style={{...buttonStylesGreen(false),...{width: device=='desktop'?'91px':'100%',order:device=='desktop'?'1':'0'}}}
                                onClick={() => {
                                    validerDocument(document?.id, 'valide');

                                }}
                            >
                                {i18n.t('Valider')}
                            </Button>
                        </div>
                    }
                    <div className='frame1DialogVisualiserDocument'>
                        <h5 className='frame2DialogVisualiserDocument'>
                            {i18n.t('Document à valider')}
                        </h5>
                        <div className='frame3DialogVisualiserDocument'>
                            <div className='frame4DialogVisualiserDocument'>
                                <p className='frame5DialogVisualiserDocument'>{i18n.t('Type du document')}</p>
                                <div className='frame6DialogVisualiserDocument'>
                                    <TextFieldComponent
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px' },

                                        }}
                                        style={{width: '100%'}}
                                        size="small"
                                        disabled
                                        variant="outlined"
                                        value={i18n.t(searchLabelInEnumByValue(typeDocument,document?.titre))}
                                    />
                                </div>

                            </div>
                            {(document?.noDoc !='' && document?.noDoc !=undefined) &&
                                <div className='frame4DialogVisualiserDocument'>
                                    <p className='frame5DialogVisualiserDocument'>{i18n.t('Numéro du document')}</p>
                                    <div className='frame6DialogVisualiserDocument'>
                                        <TextFieldComponent
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px' },

                                            }}
                                            style={{width: '100%'}}
                                            size="small"
                                            disabled
                                            variant="outlined"
                                            value={document?.noDoc}
                                        />
                                    </div>
                                </div>
                            }
                            {(document?.dateEmission !='' && document?.dateEmission !=undefined) &&
                                <div className='frame4DialogVisualiserDocument'>
                                    <p className='frame5DialogVisualiserDocument'>{i18n.t('Date du document')}</p>
                                    <div className='frame6DialogVisualiserDocument'>
                                        <IconTextField
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },

                                            }}
                                            style={{width: '100%'}}
                                            iconStart={<CalendarIcons />}
                                            //InputProps={{
                                            //    startAdornment: (
                                            //        <div className='iconStyleStartAdornment'>
                                            //            <InputAdornment position="start">
                                            //                <CalendarIcons />
                                            //            </InputAdornment>
                                            //        </div>
                                            //    )
                                            //}}
                                            size="small"
                                            disabled
                                            variant="outlined"
                                            value={formatDateJJMMYYYY(document?.dateEmission)}
                                        />
                                    </div>
                                </div>
                            }
                            {(document?.dateValidite !='' && document?.dateValidite !=undefined) &&
                                <div className='frame4DialogVisualiserDocument'>
                                    <p className='frame5DialogVisualiserDocument'>{i18n.t('Date de validité')}</p>
                                    <div className='frame6DialogVisualiserDocument'>
                                        <IconTextField
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px' },

                                            }}
                                            style={{width: '100%'}}
                                            startIcon={<CalendarIcons />}
                                            //InputProps={{
                                            //    startAdornment: (
                                            //        <div className='iconStyleStartAdornment'>
                                            //            <InputAdornment position="start">
                                            //                <CalendarIcons />
                                            //            </InputAdornment>
                                            //        </div>
                                            //    )
                                            //}}
                                            size="small"
                                            disabled
                                            variant="outlined"
                                            value={formatDateJJMMYYYY(document?.dateValidite)}
                                        />
                                    </div>
                                </div>
                            }
                            <div className='frame4DialogVisualiserDocument'>
                                <p className='frame5DialogVisualiserDocument'>{i18n.t('Date de téléchargement')}</p>
                                <div className='frame6DialogVisualiserDocument'>
                                    <IconTextField
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },

                                        }}
                                        style={{width: '100%'}}
                                        size="small"
                                        iconStart={<CalendarIcons />}
                                        //InputProps={{
                                        //    startAdornment: (
                                        //        <div className='iconStyleStartAdornment'>
                                        //            <InputAdornment position="start">
                                        //                <CalendarIcons />
                                        //            </InputAdornment>
                                        //        </div>
                                        //    )
                                        //}}
                                        disabled
                                        variant="outlined"
                                        value={formatDateJJMMYYYY(document?.createdAt)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='frame7DialogVisualiserDocument'>
                            <svg
                                width={device=='desktop'?'236':'100%'}
                                height="1"
                                viewBox={device=='desktop' ?'0 0 280 1':'0 0 100% 1'}
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <line
                                    x1="0.5"
                                    y1="0.5"
                                    x2={device=='desktop'?'279.5':'100%'}
                                    y2="0.5"
                                    stroke="#C3C9F1"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>
                        {device=='desktop' &&
                        <div className='frame8DialogVisualiserDocument'>

                            <Button
                                variant='text'
                                style={{...buttonStyles(),
                                    ...{
                                        borderColor:'#EC5B56',color:'#EC5B56',width: device=='desktop'?'91px':'100%',}
                                }}
                                onClick={() => {
                                    setOpenDialogRejet(true);

                                }}
                            >
                                {i18n.t('Rejeter')}
                            </Button>

                            <Button
                                variant='contained'
                                style={{...buttonStylesGreen(false),...{width: device=='desktop'?'91px':'100%',}}}
                                onClick={() => {
                                    validerDocument(document?.id, 'valide');

                                }}
                            >
                                {i18n.t('Valider')}
                            </Button>
                        </div>
                        }

                    </div>
                </div>

            </Dialog>
            <DialogRejet
                handleCloseDialogRejet={() => {
                    setOpenDialogRejet(false);
                }}

                handleCloseDialogVisualiserDocument={() => {
                    handleClose();
                    getDocumentAdministratifs();
                }}
                openDialogRejet={openDialogRejet}
                idDoc={document?.id}
            />
        </>
    );
};

export default DialogVisualiserDocument;
{/*<div className='row'>
                <div className='col-9 p-5'>
                    <Preview id={'jsx-template'} >
                        <Logo />
                        <h5 style={{ textAlign: 'center' }}> Ordre de document</h5>
                        <div
                            style={styleTitre}
                        >
                            <p>
                                Numéro de l&apos;ordre de document: PC##{document.missionId}
                            </p>
                            <p>
                                Date d&apos;émision: {formatDateJJMMYYYY(document.createdAt)}
                            </p>
                        </div>
                        <p style={subtitleStyle}> {JSON.stringify(document)}</p>

                    </Preview>
                </div>
                <div className='col-3 p-5'>
                    <h4>Ordre de document à valider </h4>
                    <p>{document?.titre}</p>
                    {children}
                    <Spinner
                        animation="border"
                        role="status"
                        hidden={pordreMissionLoaded}
                    >
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <Button
                        variant='outlined'
                        startIcon={<Download />}
                        sx={{ bgColor: 'palette.success.light' }}
                        onClick={printOrdreMission}
                    >
                        Télécharger l&apos;ordre de document
                    </Button>
                    <br />
                    <br />
                    <div id='propositionCommDiv'>
                        <Button
                            variant='text'
                            sx={{ bgColor: 'palette.success.light' }}
                            onClick={handleClickOpenNested}
                        >
                            rejeter
                        </Button>
                        <Button
                            variant='contained'
                            color='success'
                            sx={{ bgColor: 'palette.success.light' }}
                            onClick={() => switchOrdreMission('accept')}
                        >
                            Valider
                        </Button>
                        <Dialog
                            open={openNested}
                            onClose={handleCloseNested}
                        >
                            <DialogContent>
                                <p>
                                    votre motif de Rejet
                                </p>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    label='Note'
                                    // placeholder="Entrer içi un commentaire:"
                                    multiline
                                    minRows={4}
                                    style={{ width: 200 }}
                                    value={motifRejet}
                                    onChange={(e) => setMotifRejet(e.target.value)}
                                    autoFocus
                                    margin="dense"
                                    fullWidth
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCloseNested}>Cancel</Button>
                                <Button onClick={()=> switchOrdreMission('reject')}>Envoyer</Button>
                            </DialogActions>
                        </Dialog>
                        <Snackbar
                            open={openSnackBar}
                            autoHideDuration={6000}
                            onClose={handleCloseSnackBar}
                        >
                            <Alert
                                onClose={handleCloseSnackBar}
                                severity="info"
                                sx={{ width: '100%' }}
                            >
                              message : { message}
                            </Alert>
                        </Snackbar>
                    </div>
                </div>
            </div>*/}
